import { faLaptop, faPaperPlane } from '@fortawesome/pro-light-svg-icons';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import React, { CSSProperties, FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Hr } from '../layout';
import { Heading, Text } from '../typography';
import ModalWrapper from './ModalWrapper';
import {
  Content,
  Container,
  HeaderBlock,
  CloseButton,
  Logo,
  SubtitleBlock,
  LinksContainer,
  LinkItem,
  Icon,
} from './WhiteModal.style';

interface Props {
  ariaLabel?: string;
  show: boolean;
  onClose: () => void;
  landingPageUrl?: string;
  websiteUrl?: string;
  closeRef?: React.RefObject<HTMLButtonElement>;
  title?: string;
  subtitle?: string;
  logo?: string;
  maxWidth?: number;
  contentStyle?: CSSProperties;
  agent?: string;
}

const WhiteModal: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <ModalWrapper show={props.show} onClose={props.onClose}>
      <Container>
        <HeaderBlock>
          {props.logo && <Logo data-testid="logo" src={props.logo} />}

          {props.title && <Heading data-testid="title">{props.title}</Heading>}
        </HeaderBlock>

        {props.subtitle && (
          <SubtitleBlock data-testid="subtitle">
            <Text fontSize={18} fontWeight="600">
              {props.subtitle}
            </Text>
          </SubtitleBlock>
        )}

        <Content maxWidth={props.maxWidth} style={props.contentStyle}>
          <CloseButton
            ref={props.closeRef}
            onClick={props.onClose}
            aria-label="Close enquiry modal"
            data-testid="closeModalButton"
          >
            <FontAwesomeIcon icon={faTimes} color={theme.backgroundDark} style={{ fontSize: 32, margin: 10 }} />
          </CloseButton>

          {props.children}
        </Content>
        <Hr style={{ marginTop: '20px', maxWidth: '1024px' }} />
        <LinksContainer>
          {props.landingPageUrl && (
            <Link href={props.landingPageUrl} passHref>
              <a>
                <LinkItem data-testid="landingLink">
                  <Icon>
                    <FontAwesomeIcon color="#4a4a4a" icon={faPaperPlane} size="lg" />
                  </Icon>
                  <Text fontSize={10} style={{ marginLeft: '10px' }}>
                    Request a Valuation from {props.agent}
                  </Text>
                </LinkItem>
              </a>
            </Link>
          )}
          {props.websiteUrl && (
            <Link href={props.websiteUrl} passHref>
              <a>
                <LinkItem data-testid="websiteLink">
                  <Icon>
                    <FontAwesomeIcon color="#4a4a4a" icon={faLaptop} size="lg" />
                  </Icon>
                  <Text fontSize={10} style={{ marginLeft: '10px' }}>
                    Visit {props.agent} Website
                  </Text>
                </LinkItem>
              </a>
            </Link>
          )}
        </LinksContainer>
      </Container>
    </ModalWrapper>
  );
};

export default WhiteModal;
